module.exports = __webpack_public_path__ + "static/media/main-hatching-success.1a8c3dc5.mp3";